"use client";

import { Button } from "@/components/ui/button";

import { Form, FormControl, FormField, FormItem } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { AlertCircle, Loader2 } from "lucide-react";
import { useForgotPasswordUser } from "../hooks/use-reset";

// Common styles
const inputStyles =
  "rounded-lg border-neutral-200 focus:border-neutral-500 focus:ring-neutral-500";

export function ForgotPasswordForm() {
  const { form, onSubmit, isLoading, error } = useForgotPasswordUser();

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        aria-label="Forgot password form"
        className="flex flex-col gap-3 max-w-sm w-full"
      >
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  autoComplete="email"
                  placeholder="Email"
                  type="email"
                  aria-label="Email address"
                  required
                  {...field}
                  className={inputStyles}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <Button
          disabled={isLoading}
          aria-busy={isLoading}
          className="w-full bg-neutral-950 text-white transition-all hover:bg-neutral-800"
        >
          {isLoading && (
            <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />
          )}
            Reset Password
        </Button>

        {error && (
          <div
            className="flex w-full items-center justify-center gap-2 rounded-lg bg-red-50 p-2 text-red-500"
            role="alert"
            aria-live="polite"
          >
            <AlertCircle className="size-4" aria-hidden="true" />
            <p className="text-sm font-medium">{error}</p>
          </div>
        )}
      </form>
    </Form>
  );
}
